// ponytail: local drop-in replacement for @mui/styles/makeStyles.
// Backed by @emotion/css. Same call signature:
//   const useStyles = makeStyles((theme) => ({ root: {...}, btn: {...} }));
//   const useStyles = makeStyles({ root: {...} });   // object form
//   const classes = useStyles();                    // no params
//   const classes = useStyles({ open: true });      // per-param overrides
import { css } from "@emotion/css";
import { useTheme } from "@mui/material/styles";
import { useMemo } from "react";

// ponytail: no key transform — emotion accepts camelCase and kebab-case keys;
// transforming keys corrupts selectors ("&.Mui-selected") and media queries.
function toClasses(rawStyles, params) {
  const classes = {};
  for (const key of Object.keys(rawStyles)) {
    const style = rawStyles[key];
    const resolved = typeof style === "function" ? style(params || {}) : style;
    classes[key] = css(resolved);
  }
  return classes;
}

export default function makeStyles(stylesOrFn) {
  return function useStyles(params) {
    const theme = useTheme();
    const key = params ? JSON.stringify(params) : "";
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return useMemo(() => {
      const raw =
        typeof stylesOrFn === "function" ? stylesOrFn(theme) : stylesOrFn;
      return toClasses(raw, params);
    }, [theme, key]);
  };
}

export { makeStyles };
